export const tvUnits = [
  {
    slug: "duo-theatre",
    index: "01",
    name: "Duo Theatre",
    finish: "Lamitex Laminate",
    layout: "Full-height media wall",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/qdc11r5q_IMG_6779.jpg",
    alt: "Duo Theatre media wall in Lamitex laminate mixing wood and solid colour",
    description: "Duo Theatre plays two moods against each other — warm woodgrain Lamitex laminate overhead, deep solid colour below, with illuminated niches breaking the rhythm. The mix-and-match of wood and solid colour frames your screen like a stage, while concealed storage keeps the performance clutter-free.",
    materials: ["Lamitex laminate fronts, woodgrain + solid colour", "Illuminated display niches", "Concealed push-to-open storage", "E1-grade, low-emission board core"],
  },
  {
    slug: "terra-ceramica",
    index: "02",
    name: "Terra Ceramica",
    finish: "Ceramic + Wooden Lamitex",
    layout: "Feature wall with open library",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/f2jr6gmy_IMG_6777.jpg",
    alt: "Terra Ceramica media wall combining ceramic-look panels with wooden Lamitex laminate",
    description: "Terra Ceramica is texture on texture — a ceramic-look backdrop with the depth of quarried stone, wrapped in wooden Lamitex laminate shelving that warms the whole composition. Books, objects and flame sit inside a wall that feels carved rather than built.",
    materials: ["Ceramic-finish feature backdrop", "Wooden Lamitex laminate shelving", "Open library bays", "Integrated ambient lighting"],
  },
  {
    slug: "meridian-wall",
    index: "03",
    name: "Meridian Wall",
    finish: "Laminate",
    layout: "Panelled wall with floating console",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/1ztaby8n_IMG_6776.jpg",
    alt: "Meridian Wall TV unit in warm wood laminate panelling with floating console",
    description: "Meridian is restraint done beautifully — floor-to-ceiling wood laminate panelling with a single line of light, and a long floating console that grounds the screen. The laminate surface is resilient, consistent and effortless to maintain, so the wall looks composed for years.",
    materials: ["High-pressure laminate wall panelling", "Floating console with soft-close drawers", "LED cove lighting detail", "Precision edge-banded panels"],
  },
  {
    slug: "sensa-matt",
    index: "04",
    name: "Sensa Matt",
    finish: "Senosan Acrylic, Matt",
    layout: "Minimal floating media console",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/p3u0mqkq_IMG_6778.jpg",
    alt: "Sensa Matt TV console in velvety Senosan matt acrylic",
    description: "Sensa Matt whispers — Senosan acrylic in a velvety matt finish that swallows reflection and feels soft to the touch. Anti-fingerprint and serene, the long floating console lets light and shadow do the decorating while your screen floats effortlessly above.",
    materials: ["Senosan acrylic fronts, super-matt", "Anti-fingerprint soft-touch surface", "Floating wall-mounted construction", "Handleless push-to-open drawers"],
  },
  {
    slug: "sensa-duo",
    index: "05",
    name: "Sensa Duo",
    finish: "Senosan Matt + Lamitex",
    layout: "Gallery media wall with display vitrines",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/emj0aph3_IMG_6775.jpg",
    alt: "Sensa Duo media wall combining Senosan matt acrylic with Lamitex laminate and glass vitrines",
    description: "Sensa Duo is the best of both surfaces — fluted Senosan acrylic in soft matt above, lit glass vitrines and Lamitex laminate around the screen below. Objects glow inside the displays while the laminate keeps the working zones durable, composed and calm.",
    materials: ["Senosan acrylic fluted panels, matt", "Lamitex laminate base and frame", "Black-profile glass display vitrines", "Integrated LED shelf lighting"],
  },
];
